import type { Dispatch, AnyAction } from 'redux';

import * as CreateOrganizationDocumentsAPI from 'ab-api/web/organizationDocument/createDocument';
import * as DeleteOrganizationDocumentsAPI from 'ab-api/web/organizationDocument/deleteDocument';
import * as FindOrganizationDocumentsAPI from 'ab-api/web/organizationDocument/findDocumentsTable';

import type { GetRootState } from 'af-reducers';

import { errorHandler } from 'af-utils/actions.util';
import { http } from 'af-utils/http.util';

import { TableQuery } from 'ab-common/dataStructures/tableQuery';

export function findOrganizationDocumentsTable(tableRequestModel: TableQuery) {
	return async (dispatch: Dispatch<AnyAction>, getState: GetRootState, { redirectTo }) => {

		const action = async () => {
			const data = new TableQuery(tableRequestModel);
			return await http.get<FindOrganizationDocumentsAPI.W_OrganizationDocument_FindAllDocumentsTable_VM>(
				FindOrganizationDocumentsAPI.URL(data)
			);
		};

		return await errorHandler(action, dispatch, redirectTo);
	};
}

export function deleteOrganizationDocument(id: number) {
	return async (dispatch: Dispatch<AnyAction>, getState: GetRootState, { redirectTo }) => {

		const action = async () => {
			return await http.delete(
				DeleteOrganizationDocumentsAPI.URL(id)
			);
		};

		return await errorHandler(action, dispatch, redirectTo);
	};
}

export function createOrganizationDocument(request: CreateOrganizationDocumentsAPI.W_OrganizationDocument_CreateOrganizationDocument_RM) {
	return async (dispatch: Dispatch<AnyAction>, getState: GetRootState, { redirectTo }) => {

		const action = async () => {
			return await http.post(
				CreateOrganizationDocumentsAPI.URL(),
				request
			);
		};

		return await errorHandler(action, dispatch, redirectTo);
	};
}

